import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Victorian Curriculum"
      description="2024 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function VicCurriculumPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Victorian Curriculum"
        subtitle="2024 teacher planning resource"
        id="VIC_CURRICULUM"
        redirectUrl="https://stileapp.com/go/Vic2024"
        image={
          <StaticImage src="../../../../stile-shared/assets/images/resources/vic_2024.png" alt="" />
        }
      >
        <p>
          Stile is a complete, coherent curriculum for Australian science classrooms. This Scope and
          Sequence is aligned to the Victorian Curriculum.
        </p>
        <p>
          It offers a world-class starting point for designing your school’s science curriculum. It
          can be used in its current format alongside our comprehensive teaching plan, or it can be
          customised to best suit your unique context.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default VicCurriculumPage;
